import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const editorToolbarPluginKey: PluginKey = new PluginKey('editorToolbarPluginKey');
